import {BaseMuWidget} from "../BaseMuWidget";
import {PqmIOputData, PqmPacket, PqmProcData, PqmProcDataFields} from "./pqmTypes";
import {MuNamedWidgets} from "mu-widget/lib/MuWidget";
import {TreeView} from "../components/TreeView";
import {PqmField} from "./PqmField";
import {changeClassStartsWith, flashInfo} from "../Utils";
import {PqmCL} from "../generated/PqmCL";
import {PqmTicketDetail} from "./PqmTicketDetail";

export class PqmPackets extends BaseMuWidget
{
	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		fields: TreeView,
	}>;

	public disabled: boolean = false;

	// @ts-ignore
	muParent: PqmTicketDetail;

	public cl = new PqmCL();

	beforeIndex() {
		this.muAppendContent(`
			<div class="proc-data-field--packets" mu-id="main">
				<div class="proc-data-field--packets--header">
					<h2 mu-id="label">Vstupy</h2>
					<div class="checkbox">
						<span class="btn btn-secondary icon-before-checked-on" mu-id="bCheckAll">označit vše</span>
						<label class="checkbox"><input type="checkbox" mu-id="cSwitchDetails">Podrobnosti <span mu="detailsLabel"></span></label>
					</div>
				</div>
				<div mu="fields:TreeView">
					<div mu=":PqmField@item"></div>
				</div>
				<div mu="pRejectForm" style="display: none">
					<h3>Vyžádat doplnění pro vybrané vstupy</h3>
					<div mu="rejectReason:Htmlarea"></div>
					<div class="buttons">
						<span class="btn btn-primary" mu="bReject">Vyžádat doplnění</span>
					</div>
				</div>
			</div>
		`);
	}

	// @ts-ignore
	public packetsData: PqmIOputData;

	muBindData(srcData: PqmIOputData) {
		this.packetsData = srcData;
		super.muBindData(srcData);
		this.ui.label.innerText = srcData.isInput ? "Vstupy" : "Výstupy";
		this.ui.detailsLabel.innerText = srcData.isInput ? "vstupů" : "výstupů";
		this.muVisible(!srcData.isInput, 'bCheckAll');
		this.ui.fields.innerHTML = '';
		this.muNamedWidget.fields.render(
			srcData.packets,
			{
				srcStructFormat: "parentField",
				itemWidgetParams: { disabled: this.disabled },
			}
		)
		this.ui.main.classList.toggle('proc-data-field--packets--disabled', this.disabled);
	}

	cSwitchDetails_change() {
		this.container.classList.toggle('details-visible', this.ui.cSwitchDetails.checked);
	}

	bCheckAll_click() {
		for(const field of this.muNamedWidget.fields.muSubWidgets) {
			/*@type PqmField */
			(field as unknown as PqmField).checkIsComplete();
		}
	}

	async bReject_click() {
		const res = await this.cl.requireCompletion(
			this.muParent.pqmProcData.procDataId,
			this.getRejected(),
			this.muNamedWidget.rejectReason.muFetchData(),
			this.muParent.ticketId,
		);
		flashInfo(res ? 'Bylo požádáno o doplnění' : 'Nemáte oprávnění požádat o dopnění, byl pouze přidán komentář.');
		this.getRejectedItems().forEach(widget => widget.markCompletion());
		this.updateRejected();
		this.callMethodInFirstAncestors('reloadTicketTree');
	}

	getData(): PqmProcDataFields
	{
		const res: PqmProcDataFields = {};
		for(const fieldWidget of (this.muNamedWidget.fields.muSubWidgets as unknown as PqmField[])) {
			res[fieldWidget.pqmPacketData.pqmPacketId] = fieldWidget.getFieldData();
		}

		return res;
	}

	setData(data: PqmProcDataFields): void
	{
		for(const fieldWidget of (this.muNamedWidget.fields.muSubWidgets as unknown as PqmField[])) {
			if (data[fieldWidget.pqmPacketData.pqmPacketId])
				fieldWidget.setFieldData(data[fieldWidget.pqmPacketData.pqmPacketId]);
		}
	}

	async afterSave(res: PqmProcData) {
		const proms = [];
		for(const fieldWidget of (this.muNamedWidget.fields.muSubWidgets as unknown as PqmField[])) {
			proms.push(fieldWidget.afterSave(res));
		}
		return Promise.all(proms);
	}

	updateRejected() {
		this.muVisible(this.getRejected().length > 0 && this.packetsData.isInput, 'pRejectForm');
	}

	getRejectedItems(): PqmField[] {
		return (this.muNamedWidget.fields.itemWidgets as unknown as PqmField[])
			.filter(item => {
				const ch = item.ui.reject;
				return ch.checked && !ch.disabled;
			});
	}
	getRejected(): number[]|PqmField[] {
		return this.getRejectedItems().map(item => (item as unknown as PqmField).pqmPacketData.pqmPacketId);
	}
}